import type { CollectionActivity, PublicRelease } from "../api/types";
import { formatPackContext } from "../components/ReleaseMeta";

export type HistoryPresentation = {
  label: string;
  deltaLabel: string | null;
  tone: "add" | "remove" | "undo" | "baseline";
};

export function presentHistoryActivity(activity: CollectionActivity): HistoryPresentation {
  if (activity.kind === "BASELINE") {
    return { label: "Было в коллекции", deltaLabel: activity.quantity > 1 ? `${activity.quantity} шт.` : null, tone: "baseline" };
  }
  if (activity.kind === "UNDO") {
    return { label: activity.delta > 0 ? "Отменено удаление" : "Отменено добавление", deltaLabel: formatDelta(activity.delta), tone: "undo" };
  }
  return activity.kind === "ADD"
    ? { label: "Добавлено в коллекцию", deltaLabel: formatDelta(activity.delta), tone: "add" }
    : { label: "Удалено из коллекции", deltaLabel: formatDelta(activity.delta), tone: "remove" };
}

function formatDelta(delta: number): string { return `${delta > 0 ? "+" : "−"}${Math.abs(delta)}`; }

export function historyReleaseContext(release: PublicRelease): string {
  if (release.packName) return `${release.year} · 5-Pack · ${formatPackContext(release) ?? release.packName}`;
  return [release.year, release.seriesName, release.color, release.variation].filter((value): value is string | number => value !== null && value !== "").join(" · ");
}

export function historyDateGroup(occurredAt: string | null, now = new Date()): string {
  if (!occurredAt) return "До начала истории";
  const date = new Date(occurredAt);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const eventDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const difference = Math.round((today.getTime() - eventDay.getTime()) / 86_400_000);
  if (difference === 0) return "Сегодня";
  if (difference === 1) return "Вчера";
  return new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long", year: "numeric" }).format(date);
}

export function historyTime(occurredAt: string | null): string | null {
  return occurredAt ? new Intl.DateTimeFormat("ru-RU", { hour: "2-digit", minute: "2-digit" }).format(new Date(occurredAt)) : null;
}
